var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.234375,
    y: 0.140625,
    width: 46,
    height: 46,
    rx: 13,
    fill: "#06BA63"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_58333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9453 19.7119V15.4927C17.9453 13.9261 18.5652 12.4237 19.6685 11.316C20.7718 10.2083 22.2682 9.58594 23.8286 9.58594C25.3889 9.58594 26.8853 10.2083 27.9886 11.316C29.092 12.4237 29.7118 13.9261 29.7118 15.4927V19.7119",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9884 18.4062H15.6562C13.4471 18.4062 11.6562 20.1971 11.6562 22.4062V35.7418C11.6562 37.951 13.4471 39.7418 15.6562 39.7418H31.9884C34.1976 39.7418 35.9884 37.951 35.9884 35.7418V22.4062C35.9884 20.1971 34.1976 18.4062 31.9884 18.4062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_58333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 33,
    fill: "white",
    transform: "translate(11.2344 7.14062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv7);
export default __webpack_public_path__ + "static/media/div7.ad7045a36626a333721ec69a6ea59486.svg";
export { ForwardRef as ReactComponent };